export default "__VITE_ASSET__BqIPLkf0__"